import React from 'react';

const FeatureInfoCard = ({ data }) => {
  return (
    <div
      className={`flex flex-col gap-6 md:gap-0 ${data.isImageLeft ? 'md:flex-row' : 'md:flex-row-reverse'} items-center justify-between pt-10`}
    >
      <img src={data.img} alt="" />
      <div className="flex max-w-[437px] flex-col gap-6 text-center md:text-left">
        <h2 className="traccking-[-0.64px] self-stretch text-[32px] font-medium leading-normal  text-[#012E33]">
          {data.title}
        </h2>
        <p className="traccking-[-0.22px] self-stretch text-[22px] leading-[145.45%] text-[#678285]">
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default FeatureInfoCard;
